import React from 'react';
import IosAppStoreLink from '@sls-react/components/Links/IosAppStoreLink';
import PlayStoreIcon from '@sls-react/static/svg/PlayStoreIcon';
import Image from '@sls-react/components/Image';
import GooglePlayStoreLink from '@sls-react/components/Links/GooglePlayStoreLink';
import { clickedAppCta } from '@sls-react/services/analytics/events/generic';
import classNames from 'classnames';
import { AnalyticsSource } from '@sls-react/services/analytics/AnalyticsInterfaces';
import IOS_APP_STORE from '@sls-react/static/ios-app-store.png';

interface Props {
  appText?: React.ReactNode;
  className?: string;
  src?: AnalyticsSource;
}

const GetTheAppFooter: React.FC<Props> = ({
  appText,
  className,
  src = 'footer',
}) => {
  let content;
  if (appText) {
    if (typeof appText === 'string') {
      content = <div className="mb-2 font-semibold">{appText}</div>;
    } else {
      content = appText;
    }
  } else {
    content = <div className="mb-2 font-semibold">Get the App</div>;
  }

  return (
    <div className={classNames('text-center', className)}>
      {content}

      <div className="flex items-center justify-center space-x-2">
        <IosAppStoreLink
          source="footer"
          onClick={() => clickedAppCta('ios', src)}
        >
          <Image
            className="inline-block"
            height={35}
            width={110}
            src={IOS_APP_STORE}
            alt="iOS App Store"
          />
        </IosAppStoreLink>

        <GooglePlayStoreLink onClick={() => clickedAppCta('android', src)}>
          <PlayStoreIcon height={35} width={120} />
        </GooglePlayStoreLink>
      </div>
    </div>
  );
};

export default GetTheAppFooter;
